export const APP_NAME = 'BYL HUB'
export const PERSIST_STORE_NAME = 'admin'
export const REDIRECT_URL_KEY = 'redirectUrl'
export const APP_CONFIG = {
    COMPANY_TYPE: 'company_type',
    COMPANY_SIZE: 'company_size',
    CLIENT_SOURCES: 'client_sources',
    REGION: 'region',
    CANDIDATE_SOURCES: 'candidate_sources',
    CANDIDATE_PIPELINE: 'candidate_pipeline',
    RECRUITMENT_REQUEST_STATUS: 'recruitment_request_status',
    CLIENT_PIPELINE: 'client_pipeline',
    CLIENT_SALES_ACTIVITY: 'client_sales_activity',
    LOCATION: 'location',
    COMPANY_GRADE: 'company_grade',
    USER_ROLE: 'user_role',
    CANDIDATE_LEVEL: 'candidate_level',
    LANGUAGE: 'language',
    CANDIDATE_FUNCTION: 'candidate_function',
    CANDIDATE_DEPARTMENT: 'candidate_department',
    INDUSTRY: 'industry',
    SUB_INDUSTRY: 'sub_industry',
    CANDIDATE_SKILL: 'candidate_skill',
}

export const NOTIFICATION_TYPE = {
    SUCCESS: 'success',
    ERROR: 'danger',
    WARNING: 'warning',
    INFO: 'info',
}

export const offerStatusCode = ['CF50', 'CF51', 'CF52', 'CF53']

export const JOB_PRIORITY = [
    { label: 'Low', value: 'Low' },
    { label: 'Medium', value: 'Medium' },
    { label: 'High', value: 'High' },
    { label: 'Very Urgent', value: 'Very Urgent' },
]

export const CANDIDATE_STATUS_GROUPS = [
    'Sent to Client',
    'Client Rejected',
    'Interviewed',
    'Failed Interview',
    'Offering',
    'Rejected Offer',
    'Accepted Offer',
    'Onboarded',
    'Cancel Onboarding',
]

export const CANDIDATE_STATUS_COLORS = {
    'Sent to Client': 'text-blue-500',
    'Client Rejected': 'text-red-500',
    'Interviewed': 'text-blue-500',
    'Failed Interview': 'text-red-500',
    'Offering': 'text-blue-500',
    'Rejected Offer': 'text-red-500',
    'Accepted Offer': 'text-green-500',
    'Onboarded': 'text-green-500',
    'Cancel Onboarding': 'text-red-500',
}

export const CANDIDATE_STATUS_MAPPING = {
    CF33: 'Sent to Client', // Sent to Client
    CF34: 'Client Rejected', // Client Rejected
    CF36: 'Interviewed', // Interviewed
    CF37: 'Interviewed', // Interviewed
    CF39: 'Interviewed', // Interviewed
    CF40: 'Interviewed', // Interviewed
    CF42: 'Interviewed', // Interviewed
    CF43: 'Interviewed', // Interviewed
    CF45: 'Interviewed', // Interviewed
    CF46: 'Interviewed', // Interviewed
    CF48: 'Interviewed', // Interviewed
    CF38: 'Failed Interview', // Failed Interview
    CF41: 'Failed Interview', // Failed Interview
    CF44: 'Failed Interview', // Failed Interview
    CF47: 'Failed Interview', // Failed Interview
    CF49: 'Failed Interview', // Failed Interview
    CF50: 'Offering', // Offering
    CF51: 'Rejected Offer',
    CF52: 'Accepted Offer', // Offered
    CF53: 'Onboarded', // Onboarded
    CANCEL_ONBOARDING: 'Cancel Onboarding',
  };

export const CONTRACT_STATUS = ['DFPL07', 'HHPL04']
export const CLIENT_INIT_STATUS = 'DFPL01'
export const CANDIDATE_INIT_STATUS = 'CF30'
export const CANDIDATE_CANCEL_ONBOARDING_STATUS_NAME = 'Cancel Onboarding'
export const CANDIDATE_FAIL_STATUS_CODES = [
    'CF32',
    'CF34',
    'CF38',
    'CF41',
    'CF44',
    'CF47',
    'CF49',
    'CF51',
]
